document.addEventListener('DOMContentLoaded', function() {
  let lastScrollTop = 0;
  const header = document.querySelector('.header-wrapper');

  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // Scrolling down - hide the header
      header.style.top = '-100%'; // Adjust value depending on the height of your header
    } else {
      // Scrolling up - show the header
      header.style.top = '0';
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or edge cases
  });
});